import React, { useEffect, useState, useContext } from "react";
import LoginContext from "../context/LoginContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios, { authIsValid } from "../axios";
import { useCookies } from "react-cookie";
import Glogo from "../components/Glogo";
import { formatColorCode } from "../formatCodes";

function EditFormula() {
  let defaultMaterials = [
    { code: "71060", amount: 0.0 }, //clear core
    { code: "71001", amount: 0.0 }, //opaque core
    { code: "10094", amount: 0.0 }, //gold
    { code: "10097", amount: 0.0 }, //yellow
    { code: "12035", amount: 0.0 }, //ruby
    { code: "12036", amount: 0.0 }, //red
    { code: "12045", amount: 0.0 }, //scarlet
    { code: "12038", amount: 0.0 }, //pink
    { code: "14010", amount: 0.0 }, //violet
    { code: "15054", amount: 0.0 }, //blue
    { code: "16021", amount: 0.0 }, //green
    { code: "18029", amount: 0.0 }, //black
    { code: "31911", amount: 0.0 }, //white
    { code: "60001", amount: 0.0 }, //flo yellow
    { code: "60002", amount: 0.0 }, //flo pink
    { code: "60003", amount: 0.0 }, //flo red
    { code: "60004", amount: 0.0 }, //flo green
    { code: "60005", amount: 0.0 }, //flo blue
    { code: "60006", amount: 0.0 }, //flo purple
  ];
  const { isLoggedIn, setIsLoggedIn } = useContext(LoginContext);
  const [cookies, setCookies] = useCookies();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [materialsData, setMaterialsData] = useState([...defaultMaterials]);
  const [colorData, setColorData] = useState({
    code: "",
    name: "",
    hex: "",
  });
  const [formulaData, setFormulaData] = useState(null);
  const [category, setCategory] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [personalFormula, setPersonalFormula] = useState(false);
  const [isNewFormula, setIsNewFormula] = useState(true);
  const hexRegex = /^#[0-9A-F]{6}$/i;

  const getMaterialAmount = (code) => {
    for (let i = 0; i < materialsData.length; i++) {
      if (materialsData[i].code === code) {
        return materialsData[i].amount;
      }
    }
  };

  const handleColorSubmit = async (e) => {
    e.preventDefault();
    if (category === "") {
      setErrorMessage("Choose a category");
      return;
    }
    if (hexRegex.test(colorData.hex) === false) {
      setErrorMessage("Hex code needs to be 6 characters");
      return;
    }

    try {
      const response = await axios.put("/colors/save", colorData, {
        headers: { "x-access-token": cookies.access_token },
      });

      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        alert("Color Saved");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleFormulaSubmit = async (e) => {
    e.preventDefault();
    if (category === "") {
      setErrorMessage("Choose a category");
      return;
    }

    const formulaMaterials = materialsData.filter((item) => {
      return item.amount !== 0.0;
    });
    setFormulaData((prevState) => ({
      ...prevState,
      materials: formulaMaterials,
    }));
    //console.log(`formulaData: ${JSON.stringify(formulaData)}`);
    //console.log(`colod: ${JSON.stringify(colorData)}`);
    try {
      if (personalFormula) {
        const response = await axios.put(
          "/formulas/savePersonalFormula",
          {
            ...formulaData,
            colorId: colorData._id,
            colorName: colorData.name,
            materials: formulaMaterials,
          },
          { headers: { "x-access-token": cookies.access_token } }
        );
        //console.log(response.data);
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          alert("Formula Saved");
        }
      } else {
        if (isNewFormula) {
          //new formula
          if (
            colorData.code === "" ||
            colorData.name === "" ||
            colorData.hex === ""
          ) {
            setErrorMessage("All color information required");
            return;
          }
          const response = await axios.put(
            "/formulas/saveNewGlobalFormula",
            {
              ...formulaData,
              ...colorData,
              materials: formulaMaterials,
              category,
            },
            { headers: { "x-access-token": cookies.access_token } }
          );
          if (response.data.message) {
            if (authIsValid(response.data.message) === false) {
              navigate("/mixer");
            } else {
              alert(response.data.message);
              return;
            }
          } else {
            alert("New Formula Saved");
            navigate("/formulas");
          }
        } else {
          //not a new formula
          const response = await axios.put(
            "/formulas/editGlobalFormula",
            {
              ...formulaData,
              colorId: colorData._id,
              materials: formulaMaterials,
              category,
            },
            { headers: { "x-access-token": cookies.access_token } }
          );
          if (response.data.message) {
            if (authIsValid(response.data.message) === false) {
              navigate("/mixer");
            } else {
              alert(response.data.message);
              return;
            }
          }
          //console.log(response.data);
          alert("Formula Saved");
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleColorChange = (e) => {
    let val = e.target.value;
    if (e.target.name === "hex" && val.substring(0, 1) !== "#") {
      val = "#" + val;
    }

    if (isNewFormula && e.target.name === "code") {
      setColorData((prevState) => ({
        ...prevState,
        name: `Pantone ${val}`,
      }));
    }

    setColorData((prevState) => ({
      ...prevState,
      [e.target.name]: val,
    }));
  };

  const handleMaterialChange = (e) => {
    let val = Number(e.target.value);
    if (val < 0) {
      val = 0;
    }

    const newData = materialsData.map((item) => {
      if (item.code === e.target.name) {
        return { code: e.target.name, amount: val };
      } else {
        return item;
      }
    });

    setMaterialsData(newData);
  };

  const handleCommentChange = (e) => {
    setFormulaData((prevState) => ({
      ...prevState,
      comments: e.target.value,
    }));
  };

  const calculateTotalAmount = () => {
    let total = 0.0;
    for (let i = 0; i < materialsData.length; i++) {
      total += Number(materialsData[i].amount);
    }
    return total.toFixed(2);
  };

  const foo = (data) => {
    for (let i = 0; i < data.materials.length; i++) {
      for (let j = 0; j < defaultMaterials.length; j++) {
        if (data.materials[i].material.code === defaultMaterials[j].code) {
          defaultMaterials[j].amount = data.materials[i].amount / 100.0;
        }
      }
    }
    data.materials = defaultMaterials;
    setMaterialsData([...defaultMaterials]);
    setFormulaData({ ...data });
    setColorData({ ...data.color });
  };

  useEffect(() => {
    const fetchFormulaData = async (formulaId, personalFormula) => {
      try {
        const response = await axios.get(
          `/formulas/getFormula/${formulaId}/${personalFormula}`,
          {
            headers: {
              "x-access-token": cookies.access_token,
            },
          }
        );
        if (response.data.message) {
          if (authIsValid(response.data.message) === false) {
            navigate("/mixer");
          } else {
            alert(response.data.message);
          }
        } else {
          foo(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (location.state) {
      setCategory(location.state.category);
      setIsNewFormula(false);
      setPersonalFormula(location.state.personalFormula);
      /*console.log(
        `for: ${location.state.formulaId}, personal: ${personalFormula}, new: ${isNewFormula}, cat: ${location.state.category}`
      );*/

      fetchFormulaData(
        location.state.formulaId,
        location.state.personalFormula
      );
    }
  }, []);

  return (
    <>
      <div className="adminHeader col-12">
        <h5>{`${isNewFormula ? "Create New" : "Edit"} Formula`}</h5>
      </div>
      <div
        className="row col-12 justify-content-center"
        style={{ marginTop: 25 }}
      >
        {!personalFormula && (
          <>
            <div className="row col-md-10 col-xs-12">
              <h5 className="futuraBold">Category</h5>
            </div>
            <div
              className="row col-md-10 col-xs-12 justify-content-center"
              style={{ marginBottom: 20 }}
            >
              <div
                className="col-md-11 col-xs-12"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                }}
              >
                <div className="form-group col-md-3 col-sm-6 col-xs-8">
                  <label
                    htmlFor="category"
                    className="col-md-4 col-sm-5 col-form-label"
                    style={{ marginRight: 20 }}
                  >
                    Type:
                  </label>
                  <select
                    id="category"
                    name="category"
                    className="form-select"
                    required
                    value={category !== "" ? category : ""}
                    style={{ minWidth: 200, maxWidth: 250 }}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option hidden value="">
                      Choose...
                    </option>
                    <option value="UD">Uncoated Direct to Fabric</option>
                    <option value="UB">Uncoated Under Base</option>
                    <option value="CD">Coated Direct to Fabric</option>
                    <option value="CB">Coated Under Base</option>
                    <option value="D">Discharge</option>
                  </select>
                </div>
                <div className="col-md-2 col-sm-5 col-xs-3">
                  <p style={{ margin: 0, lineHeight: "38px", color: "red" }}>
                    {errorMessage}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row col-md-10 col-xs-12">
          <h5 className="futuraBold">Color Information</h5>
        </div>
        <div className="row col-md-10 col-xs-12 justify-content-center">
          <form className="col-md-11" onSubmit={handleColorSubmit}>
            {/*<div className="row col-md-12 justify-content-center">*/}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                padding: 0,
                justifyContent: "space-between",
                rowGap: 20,
              }}
            >
              <div
                className="form-group"
                style={{ flexGrow: 0.5, marginRight: 20 }}
              >
                {/*col-md-2 col-sm-6 col-xs-6">*/}
                <label
                  htmlFor="editColorCode"
                  className="col-form-label"
                  style={{ marginRight: 20 }}
                >
                  Color Code:
                </label>
                <div>
                  <input
                    id="editColorCode"
                    className="form-control input-lg"
                    name="code"
                    type="text"
                    disabled={
                      personalFormula || (!personalFormula && category === "")
                    }
                    placeholder="ex. 907 C"
                    required
                    value={colorData !== null ? colorData.code : ""}
                    style={{ flexGrow: 1 }}
                    onChange={(e) => handleColorChange(e)}
                    onBlur={(e) => {
                      setColorData((prevState) => ({
                        ...prevState,
                        code: formatColorCode(
                          e.target.value.trim().toUpperCase(),
                          category.substring(0, 1)
                        ),
                      }));
                    }}
                  />
                </div>
              </div>
              <div
                className="form-group"
                style={{ flexGrow: 0.5, marginRight: 20 }}
              >
                <label
                  htmlFor="colorName"
                  className="col-form-label"
                  style={{ marginRight: 20 }}
                >
                  Name:
                </label>
                <div className="" style={{ flexGrow: 1 }}>
                  <input
                    id="colorName"
                    className="form-control input-lg"
                    name="name"
                    type="text"
                    disabled={!personalFormula}
                    required
                    value={
                      colorData !== null ? `Pantone ${colorData.code}` : ""
                    }
                    onChange={(e) => handleColorChange(e)}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  marginTop: -6,
                  justifyContent: "space-between",
                  rowGap: 15,
                }}
              >
                <div className="form-group">
                  <label
                    htmlFor="colorHex"
                    className="col-form-label"
                    style={{ marginRight: 20 }}
                  >
                    Hex:
                  </label>
                  <div>
                    <input
                      id="colorHex"
                      className="form-control input-lg"
                      name="hex"
                      type="text"
                      placeholder="#ffffff"
                      required
                      disabled={personalFormula}
                      style={{ maxWidth: "70%" }}
                      value={colorData !== null ? colorData.hex : ""}
                      onChange={(e) => handleColorChange(e)}
                    />
                  </div>
                </div>
                <Glogo
                  hasStroke={true}
                  size="lg"
                  color={colorData.hex ? colorData.hex : "#ffffff"}
                />
                {!personalFormula && !isNewFormula && (
                  <button className="btn btn-md btn-ryoForest" type="submit">
                    Save Color
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
        <hr style={{ marginTop: "20px" }} />
        <div className="row editFormulaInfo col-md-10 col-xs-12">
          <h5 className="futuraBold">Formula Information</h5>
          <form className="row col-md-12" onSubmit={handleFormulaSubmit}>
            <div className="col-md-8">
              <div className="row">
                <h5>Bases</h5>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="clearBase"
                  >
                    Clear Base (71060):{" "}
                  </label>
                  <input
                    id="clearBase"
                    className="form-control input-lg"
                    name="71060"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("71060")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="opaqueBase"
                  >
                    Opaque Base (71001):{" "}
                  </label>
                  <input
                    id="opaqueBase"
                    className="form-control input-lg"
                    name="71001"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("71001")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <h5>Pigments</h5>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="white"
                  >
                    White (31911):{" "}
                  </label>
                  <input
                    id="white"
                    className="form-control input-lg"
                    name="31911"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("31911")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="pink"
                  >
                    Pink (12038):{" "}
                  </label>
                  <input
                    id="pink"
                    className="form-control input-lg"
                    name="12038"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("12038")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="gold"
                  >
                    Gold (10094):{" "}
                  </label>
                  <input
                    id="gold"
                    className="form-control input-lg"
                    name="10094"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("10094")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="violet"
                  >
                    Violet (14010):{" "}
                  </label>
                  <input
                    id="violet"
                    className="form-control input-lg"
                    name="14010"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("14010")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="yellow"
                  >
                    Yellow (10097):{" "}
                  </label>
                  <input
                    id="yellow"
                    className="form-control input-lg"
                    name="10097"
                    type="number"
                    step="0.01"
                    value={getMaterialAmount("10097")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="blue"
                  >
                    Blue (15054):{" "}
                  </label>
                  <input
                    id="blue"
                    className="form-control input-lg"
                    name="15054"
                    type="number"
                    value={getMaterialAmount("15054")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="ruby"
                  >
                    Ruby (12035):{" "}
                  </label>
                  <input
                    id="ruby"
                    className="form-control input-lg"
                    name="12035"
                    type="number"
                    value={getMaterialAmount("12035")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="green"
                  >
                    Green (16021):{" "}
                  </label>
                  <input
                    id="green"
                    className="form-control input-lg"
                    name="16021"
                    type="number"
                    value={getMaterialAmount("16021")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="red"
                  >
                    Red (12036):{" "}
                  </label>
                  <input
                    id="red"
                    className="form-control input-lg"
                    name="12036"
                    type="number"
                    value={getMaterialAmount("12036")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="black"
                  >
                    Black (18029):{" "}
                  </label>
                  <input
                    id="black"
                    className="form-control input-lg"
                    name="18029"
                    type="number"
                    value={getMaterialAmount("18029")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-4 col-xs-6 col-form-label"
                    htmlFor="scarlet"
                  >
                    Scarlet (12045):{" "}
                  </label>
                  <input
                    id="scarlett"
                    className="form-control input-lg"
                    name="12045"
                    type="number"
                    value={getMaterialAmount("12045")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <h5>Boosters</h5>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterYellow"
                  >
                    Flo Booster Yellow (60001):{" "}
                  </label>
                  <input
                    id="boosterYellow"
                    className="form-control input-lg"
                    name="60001"
                    type="number"
                    value={getMaterialAmount("60001")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterPink"
                  >
                    Flo Booster Pink (60002):{" "}
                  </label>
                  <input
                    id="boosterPink"
                    className="form-control input-lg"
                    name="60002"
                    type="number"
                    value={getMaterialAmount("60002")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterRed"
                  >
                    Flo Booster Red (60003):{" "}
                  </label>
                  <input
                    id="boosterRed"
                    className="form-control input-lg"
                    name="60003"
                    type="number"
                    value={getMaterialAmount("60003")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterGreen"
                  >
                    Flo Booter Green (60004):{" "}
                  </label>
                  <input
                    id="boosterGreen"
                    className="form-control input-lg"
                    name="60004"
                    type="number"
                    value={getMaterialAmount("60004")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterBlue"
                  >
                    Flo Booster Blue (60005):{" "}
                  </label>
                  <input
                    id="boosterBlue"
                    className="form-control input-lg"
                    name="60005"
                    type="number"
                    value={getMaterialAmount("60005")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label
                    className="col-md-6 col-sm-5 col-xs-6 col-form-label"
                    htmlFor="boosterPurple"
                  >
                    Flo Booster Purple (60006):{" "}
                  </label>
                  <input
                    id="boosterPurple"
                    className="form-control input-lg"
                    name="60006"
                    type="number"
                    value={getMaterialAmount("60006")}
                    required
                    onChange={(e) => handleMaterialChange(e)}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <label
                className="col-md-12 form-label"
                htmlFor="formulaComments"
                style={{ marginTop: "15px" }}
              >
                Comments:{" "}
              </label>
              <textarea
                id="formulaComments"
                className="form-control input-lg"
                name="comments"
                rows="8"
                value={formulaData !== null ? formulaData.comments : ""}
                onChange={(e) => handleCommentChange(e)}
              />
              <div
                className="formulaTotalAmount"
                style={{
                  height: "38px",
                  marginTop: "20px",
                  paddingTop: "6px",
                  float: "left",
                }}
              >
                <h5 style={{ marginTop: 0 }}>
                  Total: {calculateTotalAmount()}
                </h5>
              </div>
              <button
                className="btn btn-md btn-ryoForest"
                type="submit"
                style={{ marginTop: "20px", marginLeft: "20px" }}
              >
                Save Formula
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default EditFormula;
